import _ from "lodash";
import { MeUser } from "../../../models/me-user";
import { INetwork, Network } from "../../../services/payload/models/network";

export interface IBrandOption {
  name: string,
  type: string
}

export type INetworkFilters = {
  [K in keyof INetwork]: INetwork[K]
}

export class NetworkFilters implements INetworkFilters{
  brands: string[] = [];
  regions: string[] = [];
  subregions: string[] = [];
  markets: string[] = [];
  dealers: string[] = [];
  outlets: string[] = [];
  areaSales: string[] = [];
  subareaSales: string[] = [];
  areaAfterSales: string[] = [];
  subareaAfterSales: string[] = [];

  constructor(user?: MeUser) {
    if(user){
      this.brands = user.brand ? [user.brand] : [];
      this.regions = user.region ? [user.region] : [];
      this.subregions = user.subRegion ? [user.subRegion] : [];
      this.markets = user.market ? [user.market] : [];
      this.dealers = user.dealer ? [user.dealer] : [];
      this.outlets = user.outlet ? [user.outlet] : [];
    }
  }
}
